import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap';
import { HealthBrandService } from './health-brand.service';
import { ProjectsService } from 'app/_services/projects.service';
import { ReportService } from 'app/_services/report.service';


const moment = require('moment');
@Component({
  selector: 'app-health-brand-manager',
  templateUrl: './health-brand.component.html',
  styleUrls: ['./health-brand.component.scss']
})
export class HealthBrandManagerComponent implements OnInit {


  brandDropDownSettings: any;
  brandSelected = [];
  brandSelectedFilter = [];
  brands = [];
  notSpam = true;
  notSpam2 = false;
  reportName = "";
  dataReport: Object;

  projectDropDownSettings: any;
  projectSelected = [];
  projectSelectedFilter = [];
  projects = [];

  typeReport = 'day';
  typeReportFilter = 'day';

  typeAction = 'create';

  dtOptions: DataTables.Settings = {};
  dataList = [];
  dataTableShow = false;
  currentConfigItem: object;
  modalRef: BsModalRef;
  modalRef2: BsModalRef;
  daterange: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  daterangeFilter: any = {
    start: moment().subtract(7, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };
  dateRangeRecommand: any = {
    start: moment().subtract(1, "days").startOf('day'),
    end: moment().subtract(1, "days").endOf('day')
  };

  options = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.daterange.start,
    endDate: this.daterange.end
  };

  optionsFilter = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().endOf('day').toDate(),
    startDate: this.daterangeFilter.start,
    endDate: this.daterangeFilter.end
  };

  optionsRecommand = {
    locale: { format: 'DD/MM/YYYY' },
    timePicker: false,
    timePicker24Hour: true,
    timePickerSeconds: true,
    alwaysShowCalendars: false,
    maxDate: moment().subtract(1, "days").endOf('day').toDate(),
    startDate: this.dateRangeRecommand.start,
    endDate: this.dateRangeRecommand.end
  };

  showSuggestPost = false;
  listPosts = [];
  typeSentimentPost = 'neg';
  sourceRecommand = 'facebook';

  htmlRight = ``;
  ckeditorContent = ``;
  arrayPost = [];


  pageSizeRecommand = 15;
  currentPageRecommand = 1;
  totalRecommandPost = 15;

  dataReportExcel = [];

  constructor(
    private projectsService: ProjectsService,
    private toastrService: ToastrService,
    private healthBrandService: HealthBrandService,
    private modalService: BsModalService,
    private reportService: ReportService
  ) {
    this.getDataFromServer();
    this.getProject();
    this.getReportManager();
  }

  ngOnInit(): void {
    this.brandDropDownSettings = {
      singleSelection: false,
      text: 'Chọn thương hiệu',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.projectDropDownSettings = {
      singleSelection: false,
      text: 'Chọn chủ đề',
      selectAllText: 'Chọn tất cả',
      unSelectAllText: 'Bỏ chọn tất cả',
      enableSearchFilter: false,
      badgeShowLimit: 2,
    };
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [1, 2], 'searchable': true }
      ]
    };
  };

  selectedDate(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterange.start = value.start;
    this.daterange.end = value.end;

    this.options.startDate = this.daterange.start;
    this.options.endDate =  this.daterange.end;

    // change recommand date filter
    this.dateRangeRecommand.start = value.start;
    this.dateRangeRecommand.end = value.end;
    this.optionsRecommand.startDate = this.dateRangeRecommand.start;
    this.optionsRecommand.endDate =  this.dateRangeRecommand.end;
    // end change recommand date filter
  }

  selectedDateFilter(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.daterangeFilter.start = value.start;
    this.daterangeFilter.end = value.end;
  }

  selectedDateRecommand(value: any, datepicker?: any) {
    datepicker.start = value.start.startOf('day');
    datepicker.end = value.end.endOf('day');
    this.dateRangeRecommand.start = value.start;
    this.dateRangeRecommand.end = value.end;

    
    this.optionsRecommand.startDate = this.dateRangeRecommand.start;
    this.optionsRecommand.endDate =  this.dateRangeRecommand.end;
  }

  showPreviewReport(item, modalRef) {
    this.typeAction = 'view';
    this.dataReport = {};
    this.dataReport = JSON.parse(JSON.stringify(item));
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  showCreateReport(modalRef) {
    this.typeAction = 'create';
    this.dataReport = {};
    this.modalRef2 = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal'
    });
  }

  getProject() {
    this.projectsService.index().subscribe(response => {
      if (response.success) {
        response.data.projects.forEach(element => {
          let projectItem = {
            id: element._id,
            itemName: element.name,
            value: element.name
          };
          this.projects.push(projectItem);
        });
      }
    });
  }

  getDataFromServer() {
    this.dataTableShow = false;
    this.healthBrandService.getAll().subscribe(res => {
      if (res.success) {
        res.data.forEach(element => {
          let obj = {
            id: element._id,
            itemName: element.name,
            value: element.name,
            image : 'data:image/png;base64,'+element.image
          };
          this.brands.push(obj);
        });
      } else {
        this.toastrService.error('Lỗi hệ thống, Vui lòng liên hệ admin', ' Thông báo')
      }
    });
  }

  getReportManager() {
    let filter = {
      gte: this.daterangeFilter.start.valueOf(),
      lte: this.daterangeFilter.end.valueOf(),
      projects: this.projectSelectedFilter,
      brands: this.brandSelectedFilter,
      typeReport: this.typeReportFilter,
      report_code: ["BCSSSKTH"]
    };
    this.dataTableShow = false;
    this.healthBrandService.getAllReportManager(filter).subscribe(response => {
      this.dataTableShow = true;
      this.dataList = response.data;
    });
  }

  getStyle(brand: String) {
    let _brand = brand.toLowerCase()
    switch (_brand) {
      case 'vinaphone':
        return 'bg-vinaphone';
      case 'viettel':
        return 'bg-viettel'
      case 'mobifone':
        return 'bg-mobifone'
      case 'vietnammobile':
        return 'bg-vietnammobile'
      case 'fpt':
          return 'bg-fpt'
          case 'vinaphone':
        return 'bg-vinaphone';
      case 'viettel':
        return 'bg-viettel'
      case 'mobifone':
        return 'bg-mobifone'
      case 'vietnammobile':
        return 'bg-vietnammobile'
      case 'gscl_vinaphone':
        return 'bg-vinaphone';
      case 'gscl_viettel':
        return 'bg-viettel'
      case 'gscl_mobifone':
        return 'bg-mobifone'
      case 'gscl_vietnammobile':
        return 'bg-vietnammobile'
      default:
        return 'bg-primary'
    }
  }
  getImageBrand(brand : String) {
    for (let index = 0; index < this.brands.length; index++) {
      const element = this.brands[index];
      if(element.itemName == brand) {
        return element.image;
      }
    }
    return '';
  }

  showRecommentPost(modalRef) {
    this.viewPost()
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'custom-modal-1'
    });
  }

  viewPost() {
    this.showSuggestPost = false;
    if (this.projectSelected.length == 0 && this.brandSelected.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }
    this.totalRecommandPost = 0;

    if(this.sourceRecommand == 'facebook') {
      const filterFacebook = {
        filter : {
          gte: this.dateRangeRecommand.start.valueOf(),
          lte: this.dateRangeRecommand.end.valueOf()
        },
        projects: this.projectSelected,
        brands: this.brandSelected,
        size: this.pageSizeRecommand,
        from: (this.currentPageRecommand -1) * this.pageSizeRecommand,
        typeSentimentPost: this.typeSentimentPost,
        notSpam : this.notSpam,
        type: 'facebook'
      };
      this.healthBrandService.getSuggestionPost(filterFacebook).subscribe(res => {
        if (res.success) {
          this.listPosts = res.data.hits.hits;
          this.totalRecommandPost = res.data.hits.total.value < (10000 - this.pageSizeRecommand) ? res.data.hits.total.value : (10000 - this.pageSizeRecommand)
          this.showSuggestPost = true;
        }
      });
    } else {
      let filter = {
        gte: this.dateRangeRecommand.start.valueOf(),
        lte: this.dateRangeRecommand.end.valueOf(),
        projects: this.projectSelected,
        size: this.pageSizeRecommand,
        from: (this.currentPageRecommand -1) * this.pageSizeRecommand,
        sentiment: [this.typeSentimentPost],
        brands: this.brandSelected
      };
      this.healthBrandService.getArticleTopic({ filter: filter }).subscribe(res => { 
        if (res.success) {
          this.listPosts = res.data.hits.hits;
          this.totalRecommandPost = res.data.hits.total.value < (10000 - this.pageSizeRecommand) ? res.data.hits.total.value : (10000 - this.pageSizeRecommand)
          this.showSuggestPost = true;

        }
      });
    }
  
  }

  checkExitsRecommand(item) {
    let check = false;
    for (var i = 0; i < this.arrayPost.length; i++) {
      if (this.arrayPost[i].item._id == item["_source"]["docId"] || this.arrayPost[i].item._id == item["_source"]["id"]) {
        check = true;
        break;
      }
    }
    return check;
  }

  clickSaveRecommand(item) {
    this.arrayPost.push({
      type : this.typeSentimentPost,
      item : item
    });
  }

  clickRemoveRecommand(item) {
    for (var i = 0; i < this.arrayPost.length; i++) {
      if (this.arrayPost[i].item._id == item["_source"]["docId"] || this.arrayPost[i].item._id == item["_source"]["id"]) {
        this.arrayPost.splice(i, 1);
        break;
      }
    }
  }

  async savePosts() {
    let htmlRight = this.htmlRight;
    this.arrayPost.forEach(post => {
      htmlRight +=  `${post.item._source.message || post.item._source.content}<br>`;
    })
    let tempDataReport = JSON.parse(JSON.stringify(this.dataReport));
    tempDataReport['data']['contentRight'] = htmlRight;
    this.dataReport = {};
    this.dataReport = tempDataReport;

    this.modalRef.hide();
  }

  formatDate(dateField) {
    var date = new Date(dateField);
    var dateStr =
      ("00" + date.getDate()).slice(-2) + "/" +
      ("00" + (date.getMonth() + 1)).slice(-2) + "/" +

      date.getFullYear() + " " +
      ("00" + date.getHours()).slice(-2) + ":" +
      ("00" + date.getMinutes()).slice(-2) + ":" +
      ("00" + date.getSeconds()).slice(-2);
    return dateStr;
  }

  exportExcel() {
    let data = [];
    let sheet1Name =  'Báo cáo sức khỏe thương hiệu';
    let header1 = [
      { start: 1 },
       { name: "STT" }, 
       { name: "Thương hiệu" }, 
       { name: "Lượng thảo luận" }, 
       { name: "Số lượng tác giả" }, 
       { name: "Sắc thái tích cực" }, 
       { name: "Sắc thái tiêu cực" }, 
       { name: "Tổng sắc thái" }, 
       { name: "SNR" }
      ];
    let sheet1 = { name: sheet1Name, header: [header1], data:  this.dataReportExcel };
    data.push(sheet1);
    this.reportService.exportReportToExcel(data, `Báo cáo sức khỏe thương hiệu ${this.formatDate(this.daterange.start.valueOf())} - ${this.formatDate(this.daterange.end.valueOf())}`);
  }
  clickReport() {
    if (this.projectSelected.length == 0 && this.brandSelected.length == 0) {
      this.toastrService.warning("Bạn phải chọn thương hiệu hoặc chủ đề", "Thông báo!");
      return;
    }
    if (this.projectSelected.length > 4 || this.brandSelected.length > 4) {
      this.toastrService.warning("Vui lòng chọn tối đa 4 chủ đề hoặc thương hiệu", "Thông báo!");
      return;
    }
    this.dataReport = {};
    this.arrayPost = [];
    // let timeRange = Math.ceil((this.daterange.end.valueOf() - this.daterange.start.valueOf()) / (24 * 60 * 60 * 1000));
    // if (timeRange > 60) {
    //   this.toastrService.warning("Khoảng thời gian chọn không được quá 60 ngày!", "Thông báo!");
    //   return;
    // }

    let filter = {
      gte: this.daterange.start.valueOf(),
      lte: this.daterange.end.valueOf(),
      projects: this.projectSelected,
      brands: this.brandSelected,
      type: this.typeReport,
      index: 'full',
      notSpam : this.notSpam2
    };
    this.healthBrandService.getReport({ filter: filter,  index: 'full' }).subscribe(response => {
      let data = response.data;
      this.htmlRight = '';
      if (data) {
        let result = [];
        
        let aggregations = data.aggregations;
        this.dataReportExcel = [];
        for (var _key in aggregations) {
       
          let totalSentiment = aggregations[_key].statistic.docTypesCount.sentimentsCount.statistic.doc_count || 0;
          let sentiment = {};
          if(totalSentiment > 0) {
            aggregations[_key].statistic.docTypesCount.sentimentsCount.statistic.seg.buckets.forEach(element => {
              sentiment[element.key] = element.doc_count;
            });
          }
          let nsr = 0;
          let posPercent = ((sentiment['pos'] || 0 ) / totalSentiment) * 100;
          let negPercent = (((sentiment['neg'] || 0) / totalSentiment) * 100 );
          nsr = ((posPercent - negPercent) / (posPercent + negPercent)) * 100;

          let reportItem = {
            name: _key,
            totalNews: aggregations[_key].statistic.docTypesCount.news.doc_count || 0,
            totalPosts: aggregations[_key].statistic.docTypesCount.post.doc_count || 0,
            commentCount: aggregations[_key].statistic.docTypesCount.comment.doc_count || 0,
            likeCount: aggregations[_key].statistic.docTypesCount.post.likeCount.value || 0,
            shareCount: aggregations[_key].statistic.docTypesCount.post.shareCount.value || 0,
            userCount : aggregations[_key].statistic.docTypesCount.post.user_count.value + aggregations[_key].statistic.docTypesCount.comment.user_count.value,
            style : this.getStyle(_key),
            isProject : this.projectSelected.length > 0 ?  true : false,
            image : this.getImageBrand(_key),
            nsr : nsr.toFixed(2)
          }
          this.dataReportExcel.push({
            name : _key,
            discussionCount : reportItem.totalNews + reportItem.totalPosts +reportItem.commentCount,
            userCount : reportItem.userCount,
            posCount : sentiment['pos'] || 0,
            negCount : sentiment['neg'] || 0,
            totalSentiment : totalSentiment,
            nsr : reportItem.nsr
          });
          result.push(reportItem);
          this.htmlRight += `<b>${reportItem.name}</b> có chỉ số thiện cảm <b>NSR = ${reportItem.nsr}%</b> <br>`
        }

        // move Vinaphone lên đầu
        result.forEach(function(item,i){
          if(item.name.toLowerCase() === "vinaphone"){
            result.splice(i, 1);
            result.unshift(item);
          }
        });    
        // end move Vinaphone lên đầu
        this.dataReport = {
          report_desc: "Báo cáo so sánh sức khỏe thương hiệu",
          report_type: this.typeReport,
          report_name: "Báo cáo so sánh sức khỏe thương hiệu " + this.daterange.start.format('DD/MM/YYYY') + " đến ngày " + this.daterange.end.format('DD/MM/YYYY'),
          report_project: this.projectSelected,
          report_brand: this.brandSelected,
          report_start_date: new Date(this.daterange.start.valueOf()),
          report_end_date: new Date(this.daterange.end.valueOf()),
          report_code: "BCSSSKTH",
          data: {
            result: result,
            contentRight : this.htmlRight
          }
        }
      }
    });
    // console.log(filter);
  }
  clickSave() {
    if (this.dataReport) {
      if (this.reportName == "") {
        this.toastrService.warning("Bạn phải nhập tiêu đề cho báo cáo!", "Thông báo!");
        return;
      }
      this.dataReport["report_title"] = this.reportName.trim();
      this.healthBrandService.createReportManager(this.dataReport).subscribe(response => {
        if (response.success) {
          this.toastrService.success("Đã tạo báo cáo thành công!", "Thông báo!");
          this.getReportManager();
        } else {
          this.toastrService.warning(response.msg, "Thông báo!");
        }
        this.closeModal();
      });
    } else {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
    }
  }

  clickDeleteItem(item, modalRef) {
    this.modalRef = this.modalService.show(modalRef);
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
  }

  clickSaveConfirm(modalRef) {
    if (!this.dataReport) {
      this.toastrService.warning("Không có dữ liệu báo cáo cần cập nhật!", "Thông báo!");
      return;
    }
    this.reportName = "";
    this.modalRef = this.modalService.show(modalRef);
  }

  clickEditReportItem(item,modalRef) {
    this.currentConfigItem = JSON.parse(JSON.stringify(item));
    this.ckeditorContent = this.currentConfigItem['data'].contentRight
    this.modalRef = this.modalService.show(modalRef, {
      keyboard: false,
      backdrop: 'static',
      class: 'modal-lg'
    });
  }
  onCkEditorChange(item) {
    this.ckeditorContent = item;
  }
  saveEditPost(){
    this.currentConfigItem['data'].contentRight =  this.ckeditorContent;
    this.healthBrandService.updateReport(this.currentConfigItem['_id'], this.currentConfigItem['data']).subscribe(res => {
      if(res.success){
        this.toastrService.success('Update thành công','Thông báo');
        this.modalRef.hide();
        this.getReportManager();
        this.dataReport = null;
        this.dataReport = this.currentConfigItem;
      }
    });
  }
  deleteReport() {
    this.healthBrandService.deleteReport(this.currentConfigItem['_id']).subscribe(res => {
      if (res.success) {
        this.getReportManager();
        this.toastrService.success('Xóa báo cáo thành công !', 'Thông báo');
        this.closeModal();
      } else {
        this.toastrService.error('Xóa báo cáo thất bại !', 'Thông báo');
      }
    });
  }
  pageChange(number) {
    this.listPosts = [];
    this.currentPageRecommand = number;
    this.viewPost();
 }
  closeModal() {
    this.modalRef.hide();
    this.modalRef2.hide();
  }

  onItemSelect(item: any) {
  }
  OnItemDeSelect(item: any) {
  }

  onSelectAll(items: any) {
  }

  onDeSelectAll(items: any) {
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/health-brand/health-brand.component.ts